/**
 * Pick Batch Statuses
 *
 * These values match the backend PickBatchStatusId. Derived from the orders-grid filter
 * contract in containers/orders-filter-bar-container/static-criteria-arguments.jsx, which
 * sends no value for "No Status" and index-1 for the rest.
 */
export enum PickBatchStatus {
  ReadyToPick = 0,
  Picking = 1,
  Picked = 2,
}
